export const URLs = {
  LOGIN: '/login',
  REGISTER: '/register',
  404: '/404',
  500: '/500',
  403: '/403',
  DASHBOARD: '/dashboard',
  DEVICES: '/devices',
  METHODS: '/method',
  DEVICE_TYPE: '/device-type',
  USERS: '/users',
  CONFIG: '/configs',
  UPDATESOFTWARE: '/update-software',
}
